import React from 'react';
import styled from 'styled-components/macro';
import {
    AnimationContainer,
    Container as BaseContainer,
    Body as BaseBody
} from '../../Shared/PopupModalStyles';

import BounceForm from './BounceForm';

const Container = styled(BaseContainer)`
    width: 100;

    @media (max-width: 30em) {
        width: 100%;
    }
`;

const Body = styled(BaseBody)`
    width: 325px;
    padding: 25px 20px;
`;

const BounceModal = () => (
    <AnimationContainer>
        <Container>
            <Body>
                <BounceForm noBack={true} />
            </Body>
        </Container>
    </AnimationContainer>
);

export default BounceModal;
